import type { HTMLAttributes } from 'react'
import { cn } from './cn'

type Tone = 'ok' | 'warn' | 'error' | 'err' | 'idle' | 'info'
const tones: Record<Tone, string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  error: 'bg-err',
  err: 'bg-err',
  idle: 'bg-ink-faint',
  info: 'bg-info',
}

export interface StatusDotProps extends HTMLAttributes<HTMLSpanElement> {
  /** Canonical status tone. `err` remains as a deprecated alias for `error`. */
  tone?: Tone
  label?: string
}

/** Small status indicator dot. Pass `label` for an accessible name, else decorative. */
export function StatusDot({ tone = 'idle', label, className = '', ...props }: StatusDotProps) {
  return (
    <span
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      className={cn('inline-block w-2 h-2 rounded-full shrink-0', tones[tone], className)}
      {...props}
    />
  )
}
